import type { TokenStorage } from "@shared/types/api";

const TOKEN_KEY = "platko_token";
const REFRESH_TOKEN_KEY = "platko_refresh_token";

const storage: TokenStorage = {
  getToken: async () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },

  getRefreshToken: async () => {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setTokens: async (token: string, refreshToken: string) => {
    try {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    } catch {
      console.warn("Failed to store tokens in localStorage");
    }
  },

  clearTokens: async () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch {
      console.warn("Failed to clear tokens from localStorage");
    }
  },
};

export default storage;
